import { Maybe, Nullable, UserRelation } from '@aibees/shared/definition';

export enum MemberType {
  Owner = 'OWNER',
  Admin = 'ADMIN',
  User = 'MEMBER',
}

export enum MemberStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING',
  disable = 'INACTIVE',
  Deleted = 'DELETED',
}

export interface Member {
  user: Maybe<UserRelation>;
  created: string;
  type: MemberType;
  status: MemberStatus;
}

export interface Transfer {
  user: UserRelation;
  created: string;
  status: MemberStatus;
}

export interface Workspace {
  id: string;
  created: string;
  name: string;
  user: UserRelation;
  status: MemberStatus;
  description: Nullable<string>;
  members: Member[];
  transfer: Nullable<Transfer>;
}

export interface WorkspaceRelation {
  id: string;
  user: UserRelation;
}
